import Box from '@mui/material/Box';
import { CircularProgress } from '../components/CircularProgress';

/**
 * Carregamento exibido pelo `<Suspense>` de topo enquanto alguma tela aguarda recurso.
 *
 * Não usa `useTranslation` de propósito: o caso típico de suspensão é justamente o
 * i18next ainda carregando as traduções, e um fallback que também suspendesse não teria
 * boundary acima para segurá-lo.
 */
export function BootLoading(): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
